import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clienthad() {
  return (
    <section className="client_had p-100 text_reck">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Project Idea and Goals Set <span>for TekRevol</span>
            </h2>
            <p>
              The commencement of Reck’N was motivated by a creative idea—a
              restaurant reservation app that exceeded simple reservations.
            </p>
            <p>
              In addition to safeguarding a table, the app is expected to
              transform the dining experience by nurturing social interactions,
              protecting underage customers from forbidden products, and
              enabling shared interests among guests.
            </p>
            <p>
              TekRevol was commended for understanding this visionary notion and
              creating a platform serving customers and restaurants.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img_reck">
              <StaticImage
                src="../../../images/case-studies/reckncase/project-idea.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={763}
                height={702}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clienthad;
